import React, { useState, useContext, useEffect } from 'react'
import { IonRow, IonCol, IonItem, IonLabel, IonInput, IonIcon, IonButton, useIonViewWillEnter } from '@ionic/react'
import db from '../../resources/db';
import { add } from 'ionicons/icons';
import { ConfigContext } from '../../contexts/ConfigContext';

const AddProduct = (props) => {

    const { Config } = useContext(ConfigContext)
    const [Name, setName] = useState('');
    const [Quantity, setQuantity] = useState(1)
    const [Price, setPrice] = useState('')
    const [HSN, setHSN] = useState('')
    const [gstr, setGstr] = useState(0)

    const Amount = Quantity * Price;
    const gstInclusive = Config.gst.inclusive; // if true , its inclusive else its exclusive

    const [productList, setproductList] = useState([])

    useIonViewWillEnter(() => {
        // get the product list from the stocks table
        db.stocks.orderBy("productName").uniqueKeys().then((res) => {
            setproductList(res)
        })

        // this will attach the already present products while auto-completing the product name
        document.getElementById('name').getInputElement().then((res) => {
            res.setAttribute('list', 'products')
        })
        return () => {
            setproductList([])
        }
    }, [])

    const onSubmitHandle = (e) => {
        e.preventDefault();
        console.log(Name, Quantity, Price, Amount);
        const item = {
            id: `p_${Date.now()}`,
            name: Name.trim(),
            hsn: HSN.trim(),
            quantity: parseFloat(Quantity),
            price: gstInclusive ? parseFloat(Price * 100 / (100 + gstr)) : parseFloat(Price),
            amount: gstInclusive ? parseFloat(Amount * 100 / (100 + gstr)) : parseFloat(Amount),
            gstr: parseFloat(gstr),
            gstAmt: gstInclusive ? parseFloat(Amount * gstr / (100 + gstr)) : parseFloat((Amount * gstr) / 100),
            total: parseFloat(Amount * (100 + gstr) / 100)
        }
        item.total = item.amount + item.gstAmt
        props.addProduct(item);
        db.stocks.where("productName").equals(Name).modify((value, ref) => {
            // console.log(value , ref)
            let q = value.quantity
            // console.log(q);

            ref.value.quantity = q - (Quantity)
        })
        document.getElementById('name').setFocus()


        // clears the input fields
        setName('');
        setPrice('')
        setQuantity(1)
        setHSN('')
        setGstr(0)
    }

    const onChangeName = async e => {
        setName(e.target.value)
        // console.log(e.target.value);

        let stocks = await db.stocks.where('productName').equals(e.target.value);
        stocks.each((res) => {
            // console.log(res.rate);
            setPrice(res.rate)
            setHSN(res.hsn)
            setGstr(parseFloat(res.gstRate))
        })
    }
    const products = productList.length ? (
        productList.map((p) => {
            // console.log(p);
            return (
                <option key={p} value={p}></option>
            )
        })
    ) : (null)


    return (
        <div>
            <h5 className='red-text'> Add Product Row : </h5>
            <form className='row' onSubmit={onSubmitHandle}>
                <IonRow>
                    <IonCol>
                        <IonItem>
                            <IonLabel position='floating'>Product Name</IonLabel>
                            <IonInput type='text' autocomplete='on' id="name" value={Name} placeholder='Name' onIonInput={onChangeName} />
                            <datalist id='products'>
                                {products}
                            </datalist>
                        </IonItem>
                    </IonCol>


                    <IonCol>
                        <IonItem>
                            <IonLabel position='floating'>Quantity</IonLabel>
                            <IonInput type='number' id="quantity" placeholder='Quantity' value={Quantity} min='1' step='any' required onIonInput={(e) => { setQuantity(parseFloat(e.target.value)) }} />
                        </IonItem>
                    </IonCol>
                    <IonCol>
                        <IonItem>
                            <IonLabel position='floating'>Price</IonLabel>
                            <IonInput type='number' id="price" value={Price} placeholder='Price' min='0' step='any' required onIonInput={(e) => setPrice(parseFloat(e.target.value))} />
                        </IonItem>
                    </IonCol>
                    <IonCol>
                        <IonItem>
                            <IonLabel position='floating'>Amount</IonLabel>
                            <IonInput type='text' id="amount" value={Amount} />
                        </IonItem>
                    </IonCol>

                    {(!Config.gst.enabled) && (<IonCol>
                        <IonButton color='danger' type='submit' shape='round' >
                            <IonInput type='submit' ><IonIcon icon={add} /></IonInput>
                        </IonButton>
                    </IonCol>)}

                </IonRow>
                {
                    Config.gst.enabled && (
                        <IonRow>
                            <IonCol>
                                <IonItem>
                                    <IonLabel position='floating'>HSN Code</IonLabel>
                                    <IonInput type='text' id="hsn" value={HSN} placeholder='HSN Code' onIonInput={(e) => setHSN((e.target.value))} />
                                </IonItem>
                            </IonCol>
                            <IonCol>
                                <IonItem>
                                    <IonLabel position='floating'>GST Rate</IonLabel>
                                    <IonInput type='number' id="gstr" value={gstr} placeholder='GST Rate' min='0' step='any' onIonInput={(e) => setGstr(parseFloat(e.target.value))} />
                                </IonItem>
                            </IonCol>
                            <IonCol>
                                <IonButton color='danger' type='submit' shape='round' >
                                    <IonInput type='submit' ><IonIcon icon={add} /></IonInput>
                                </IonButton>
                            </IonCol>
                        </IonRow>
                    )
                }
            </form>
        </div>
    )
}

export default AddProduct
